import Navbar from './sections/navbar/Navbar';
import Header from './sections/header/Header';
import About from './sections/about/About';
import TrustStrip from './components/TrustStrip';
import Services from './sections/services/Services';
import Portfolio from './sections/portfolio/Portfolio';
import Testimonials from './sections/testimonials/Testimonials';
import FAQs from './sections/faqs/FAQs';
import Contact from './sections/contact/Contact';
import Footer from './sections/footer/Footer';
import FloatingNav from './sections/floating-nav/FloatingNav';
import StickyWhatsApp from './components/StickyWhatsApp';
import { useRef, useState, useEffect, useCallback } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const App = () => {
  const mainRef = useRef();
  const [showFloatingNav, setShowFloatingNav] = useState(true);
  const [siteYPostion, setSiteYPosition] = useState(0);

  const floatingNavToggleHandler = useCallback(() => {
    const currentY = mainRef.current?.getBoundingClientRect().y ?? 0;

    if (
      siteYPostion < currentY - 20 ||
      siteYPostion > currentY + 20
    ) {
      setShowFloatingNav(true);
    } else {
      setShowFloatingNav(false);
    }

    setSiteYPosition(currentY);
  }, [siteYPostion]);

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    AOS.init({
      duration: 650,
      once: true,
      easing: 'ease-out-cubic',
      offset: 48,
      delay: 0,
      disable: prefersReducedMotion,
    });

    const refreshAos = () => AOS.refresh();

    window.addEventListener('load', refreshAos);

    return () => {
      window.removeEventListener('load', refreshAos);
    };
  }, []);

  useEffect(() => {
    const checkYPosition = setInterval(
      floatingNavToggleHandler,
      2000
    );

    return () => clearInterval(checkYPosition);
  }, [floatingNavToggleHandler]);

  return (
    <>
      <Navbar />

      <main ref={mainRef} className="site-main">
        <Header />
        <About />
        <TrustStrip />
        <Services />
        <Portfolio />
        <Testimonials />
        <FAQs />
        <Contact />
        <Footer />

        {showFloatingNav && <FloatingNav />}
      </main>

      <StickyWhatsApp />
    </>
  );
};

export default App;